// Prefix attribution is an advisory validation, NOT a verified wallet lookup.
// A live payment provider must confirm the payer's actual wallet in production.
const allocations = require('../data/bfMobilePrefixes.json');

const OPERATOR_LABELS = {
  moov: 'Moov Africa',
  orange: 'Orange Burkina',
  telecel: 'Telecel Faso',
};

function normalizeBurkinaPhone(input) {
  return String(input ?? '').replace(/[\s.-]/g, '').replace(/^\+?226/, '');
}

function inspectBurkinaPhone(input, selectedProvider = null) {
  const normalized = normalizeBurkinaPhone(input);
  const valid = /^\d{8}$/.test(normalized);
  const prefix = valid ? normalized.slice(0, 2) : null;
  const operator = prefix
    ? Object.keys(OPERATOR_LABELS).find((key) => allocations[key].includes(prefix)) || null
    : null;
  // Unsupported known carriers are never accepted as a different wallet.
  // Unknown allocations are deliberately not rejected: the table may evolve.
  const compatible = valid && (!selectedProvider || !operator || operator === selectedProvider);
  return { normalized, valid, prefix, operator, compatible };
}

module.exports = { normalizeBurkinaPhone, inspectBurkinaPhone, OPERATOR_LABELS };
